import { z } from "zod";
import { ZGeoteknikKoordinaterSchema } from "../../geoteknikSchema.js";
import { ZInnledningSchema } from "./1-innledningSchema.js";
import { ZGulvMotFriluftSchema } from "./10-gulvMotFriluftSchema.js";
import { ZYtterveggerOverTerrengSchema } from "./11-ytterveggerOverTerrengSchema.js";
import { ZVinduerGlassfasaderYtterdorerSchema } from "./12-vinduerGlassFasaderYtterdorerSchema.js";
import { ZTakSchema } from "./13-takSchema.js";
import { ZSpesielleRomOgKonstruksjonerSchema } from "./14-spesielleRomOgKonstruksjonerSchema.js";
import { ZMyndighetskravSchema } from "./2-myndighetskravSchema.js";
import { ZDetaljkontrollSchema } from "./3-detaljkontrollSchema.js";
import { ZOmProsjektetSchema } from "./4-omProsjektetSchema.js";
import { ZByggfuktSchema } from "./5-byggfuktSchema.js";
import { ZBygningsmessigEnergiSchema } from "./6-bygningsmessigEnergiSchema.js";
import { ZRadonSchema } from "./7-radonSchema.js";
import { ZKonstruksjonerMotTerrengSchema } from "./8-konstruksjonerMotTerrengSchema.js";
import { ZGulvMotTemperertArealSchema } from "./9-gulvMotTemperertArealSchema.js";

export const ZBygningsfysikkPremissRapportSchema = z.object({
  generellInfo: z.object({
    oppdragsnavn: z.string(),
    emne: z.string(),
    oppdragsgiver: z.string(),
    kontaktperson: z.string(),
    dokumentkode: z.string(),
    tilgjengelighet: z.string(),
    oppdragsleder: z.string(),
    utarbeidetAv: z.string(),
    ansvarligEnhet: z.string(),
    koordinater: ZGeoteknikKoordinaterSchema,
    eiendomsInformasjon: z.object({
      gnr: z.number().nullable(),
      bnr: z.number().nullable(),
      snr: z.number().nullable(),
      kommune: z.string().nullable(),
    }),
  }),
  kapitler: z.object({
    innledning: ZInnledningSchema, // 1
    myndighetskrav: ZMyndighetskravSchema, // 2
    detaljkontroll: ZDetaljkontrollSchema, // 3
    omProsjektet: ZOmProsjektetSchema, // 4
    byggfukt: ZByggfuktSchema, // 5
    bygningsmessigEnergi: ZBygningsmessigEnergiSchema, // 6
    radon: ZRadonSchema, // 7
    konstruksjonerMotTerreng: ZKonstruksjonerMotTerrengSchema, // 8
    gulvMotTemperertAreal: ZGulvMotTemperertArealSchema, // 9
    gulvMotFriluft: ZGulvMotFriluftSchema, // 10
    ytterveggerOverTerreng: ZYtterveggerOverTerrengSchema, // 11
    vinduerGlassfasaderYtterdorer: ZVinduerGlassfasaderYtterdorerSchema, // 12
    tak: ZTakSchema, // 13
    spesielleRomOgKonstruksjoner: ZSpesielleRomOgKonstruksjonerSchema, // 14
  }),
});

export type IBygningsfysikkPremissRapport = z.infer<typeof ZBygningsfysikkPremissRapportSchema>;
